import 'slick-carousel'

// Ensure slick library has been included

if ( typeof $.fn.slick == 'function' ) {

    // Project Hero Slider

    if ( $( '.js-project-hero-slider' ).length > 0 ) {

        $( '.js-project-hero-slider' ).slick({

            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            dots: true,
            appendDots: $('.site-hero--project')

        });

    }

    // Project Single - Project Details Layout - Slick Slider Settings

    const projectSliderSettings = {

        autoplay: true,
        autoplaySpeed: 6000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        dots: true,
        lazyLoad: 'progressive'


    }

    $( '.js-project-slice-slider' ).slick(projectSliderSettings);

    $( '.js-project-slice-slider--two' ).slick(projectSliderSettings);

    $( '.js-project-sub-slice-slider' ).slick(projectSliderSettings);

    $( '.js-project-sub-slice-slider--two' ).slick(projectSliderSettings);

    $( '.js-slider' ).slick({
        mobileFirst: true,
        arrows: true,
        dots: false,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fa fa-angle-left" aria-hidden="true"></i></button></i>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 1024,
                settings: 'unslick',
            }
        ]
    });

    $( '.js-shapes' ).slick({
        mobileFirst: true,
        arrows: true,
        dots: false,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fa fa-angle-left" aria-hidden="true"></i></button></i>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: 'unslick',
            }
        ]
    });

}
